import {
  Subscription,
  SubscriptionCancellationCause,
  SubscriptionStatus,
} from "../../../../contracts/nexar-api/types";
import Event from "../../../../core/consts/analytics-events";
import { Campaigns } from "../../../../core/consts/campains";

export const subscriptionPlaceholder: Subscription = {
  lteSerialNumbers: ["placeholder1"],
  subscriptionId: "someId",
  status: "ACTIVE",
  createdAt: null,
  cancellationCause: "UNKNOWN",
  stripeSubscriptionId: "",
  recurlySubscriptionId: "",
  subscriptionQuantity: 1,
  isPrepaid: false,
  startDate: null,
  expirationDate: null,
  campaign: null,
};

export type statusSettingsCtaStyle = 'normal' | 'alt' | 'top-right';

export type statusSettings = {
  textKey: string;
  buttonTextKey: string;
  onClickEventName: Event;
  ctaStyle: statusSettingsCtaStyle;
};
export function getStatusConfig(
  status: SubscriptionStatus,
  cancellationCause: SubscriptionCancellationCause,
  campaign?: string,
  expirationDate?: string | null
): statusSettings {
  switch (status) {
    case "ACTIVE":
      if(campaign === Campaigns.freemium && !!expirationDate){
        return {
          textKey: "inactive",
          buttonTextKey: "activateNexarConnect",
          onClickEventName: Event.ConnectActivateClicked,
          ctaStyle: 'normal',
        };
      }
      return {
        textKey: "active",
        buttonTextKey: "edit",
        onClickEventName: Event.ConnectEditClicked,
        ctaStyle: 'top-right',
      };
    case "PENDING":
      return {
        textKey: "inactive",
        buttonTextKey: "activateNexarConnect",
        onClickEventName: Event.ConnectActivateClicked,
        ctaStyle: 'normal',
      };
    case "PAUSED":
      return {
        textKey: "paymentExpired",
        buttonTextKey: "updatePaymentInfo",
        onClickEventName: Event.ConnectReactivateClicked,
        ctaStyle: 'alt',
      };
    case "PENDING_CANCELLATION":
      return {
        textKey: "cancelled",
        buttonTextKey: "activateNexarConnect",
        onClickEventName: Event.ConnectActivateClicked,
        ctaStyle: 'normal',
      };
    case "INACTIVE":
      switch (cancellationCause) {
        case "PAYMENT_FAILURE":
          return {
            textKey: "paymentExpired",
            buttonTextKey: "updatePaymentInfo",
            onClickEventName: Event.ConnectReactivateClicked,
            ctaStyle: 'alt',
          };
        default:
          return {
            textKey: "cancelled",
            buttonTextKey: "activateNexarConnect",
            onClickEventName: Event.ConnectActivateClicked,
            ctaStyle: 'normal',
          };
      }
  }
}
